var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconCustomersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.8334C14.2167 10.8334 13.4917 11.1084 12.9167 11.5667C12.15 12.175 11.6667 13.1167 11.6667 14.1667C11.6667 14.7917 11.8416 15.3834 12.15 15.8834C12.725 16.85 13.7833 17.5 15 17.5C15.8417 17.5 16.6083 17.1917 17.1917 16.6667C17.45 16.45 17.675 16.1834 17.85 15.8834C18.1583 15.3834 18.3333 14.7917 18.3333 14.1667C18.3333 12.325 16.8417 10.8334 15 10.8334ZM16.725 13.8084L14.95 15.45C14.8333 15.5584 14.675 15.6167 14.525 15.6167C14.3667 15.6167 14.2083 15.5584 14.0833 15.4334L13.2583 14.6084C13.0167 14.3667 13.0167 13.9667 13.2583 13.725C13.5 13.4833 13.9 13.4833 14.1417 13.725L14.5417 14.1251L15.875 12.8917C16.125 12.6583 16.525 12.675 16.7583 12.925C16.9916 13.175 16.975 13.5667 16.725 13.8084Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.575 17.9166C17.575 18.15 17.3916 18.3333 17.1583 18.3333H2.84165C2.60832 18.3333 2.42499 18.15 2.42499 17.9166C2.42499 14.4666 5.82498 11.6666 9.99998 11.6666C10.8583 11.6666 11.6917 11.7833 12.4583 12.0083C11.9667 12.5916 11.6667 13.35 11.6667 14.1666C11.6667 14.7916 11.8416 15.3833 12.15 15.8833C12.3166 16.1666 12.5333 16.4249 12.7833 16.6416C13.3666 17.1749 14.1417 17.5 15 17.5C15.9333 17.5 16.775 17.1166 17.375 16.4999C17.5083 16.9499 17.575 17.425 17.575 17.9166Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.99996C12.3012 9.99996 14.1667 8.13448 14.1667 5.83329C14.1667 3.53211 12.3012 1.66663 10 1.66663C7.69882 1.66663 5.83334 3.53211 5.83334 5.83329C5.83334 8.13448 7.69882 9.99996 10 9.99996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconCustomersActive);
export default __webpack_public_path__ + "static/media/menu_icon_customers_active.a3629bef0ee668a773506fbc4bc9059e.svg";
export { ForwardRef as ReactComponent };